var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNiue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.001C32 24.8375 24.8365 32.001 16 32.001C7.1635 32.001 0 24.8375 0 16.001C0 16.0048 16 0.00272656 16 0.000976562C24.8365 0.000976562 32 7.16448 32 16.001Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7.65308V13.0495L10.4348 7.65308H16Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34724 16.0008H13.0479L8.34724 9.73993L7.65161 14.6095L8.34724 16.0008Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9578 16.001H16.0006C16.0006 15.9867 16.0006 15.9727 16.0006 15.9582C15.9863 15.9725 15.9721 15.9868 15.9578 16.001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.34879C16 5.53348 16 3.68879 16 0.000976562H15.9973C7.16194 0.00247656 0 7.16529 0 16.001H8.34781V11.3003L13.0485 16.001H15.9572C15.9715 15.9867 15.9858 15.9725 16.0001 15.9582C16.0001 14.8802 16.0001 13.9184 16.0001 13.0496L11.2992 8.34879H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0006 14.0332L10.3159 8.34869H8.34839V8.34882L16.0005 16.0008H16.0006C16.0006 16.0008 16.0006 14.6441 16.0006 14.0332V14.0332Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09515 2.08783C7.47834 2.43908 6.8874 2.83052 6.3254 3.25783H6.9819L5.24678 4.5187L5.9094 6.55852L4.17428 5.29789L3.98965 5.43208C3.26921 6.2502 2.63046 7.14195 2.0874 8.09558V16.0009H6.26134V6.26189V6.26177H16.0005C16.0005 4.94533 16.0005 3.6912 16.0005 2.08783H8.09515Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83557 2.88538C6.66301 3.00619 6.49288 3.13038 6.32532 3.25781L5.24688 4.51869L4.17438 5.29781L3.9882 5.43306C3.59532 5.87931 3.22688 6.34756 2.88501 6.83588C3.2747 7.025 3.71213 7.13131 4.17438 7.13131C5.80726 7.13131 7.13088 5.80769 7.13088 4.17481C7.13101 3.71244 7.02476 3.27513 6.83557 2.88538V2.88538Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98633 5.43306L4.17252 5.29781L5.90764 6.5585L5.24495 4.51869L6.97995 3.25781H6.32333C5.4737 3.904 4.69077 4.633 3.98633 5.43306V5.43306Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.058 2.78363L11.4033 3.84644H12.5208L11.6168 4.50338L11.962 5.5662L11.058 4.90932L10.1539 5.5662L10.499 4.50338L9.59497 3.84644H10.7125L11.058 2.78363Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17314 9.74017L4.51852 10.803H5.63602L4.73202 11.46L5.07721 12.5228L4.17314 11.8659L3.26902 12.5228L3.61421 11.46L2.71021 10.803H3.82771L4.17314 9.74017Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiue);
export default __webpack_public_path__ + "static/media/niue.d6a287f8.svg";
export { ForwardRef as ReactComponent };